// extracted by mini-css-extract-plugin
export default {"root":"JNU2qa","bg":"NI2qP2","shd":"n05nJL","right":"g7UZOI","left":"vEJ4Cu"};